import "./App.css";
import { EllipsoidScene } from "./Ellipsoid";

function App() {
    return (
        <div className="App">
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>
            <h1>Mid Magazine</h1>

            <EllipsoidScene />
            <p>coming soon</p>
        </div>
    );
}

export default App;
